import axios from 'axios'

import http from 'legacy/utils/http'

export function getTokenV2(data) {
  return axios.post('/api/v2/oauth/token', data, http.getPublicHeadersForm())
}
